import { clsx } from "clsx";
import { Image } from "./Image";

export const Logo = ({ className }: { className?: string }) => {
  return (
    <div
      className={clsx(
        "flex items-center text-primary-900 dark:text-white gap-1 font-logo",
        className,
      )}
    >
      <Image
        src="/landing/static/images/logo.png"
        alt="magnify logo"
        width={24}
        height={24}
        className="h-6 w-6"
        style={{ marginBottom: "9px" }}
      />
      {"magnify "}
    </div>
  );
};

export default Logo;
